var render, staticRenderFns
import script from "./TeamWorkChart.vue?vue&type=script&lang=js"
export * from "./TeamWorkChart.vue?vue&type=script&lang=js"
import style0 from "./TeamWorkChart.vue?vue&type=style&index=0&id=542c8bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c8bf2",
  null
  
)

/* custom blocks */
import block0 from "./TeamWorkChart.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(component)

export default component.exports